import { Droplets, Mountain, Box, Route, Construction, Sprout, Layers } from "lucide-react";

export const MANAGE_ROLES = ["admin", "office", "super_admin"];
export const FINANCE_ROLES = ["admin", "office", "super_admin", "quantity_surveyor"];

export const STATUS_LABEL = { in_progress: "In progress", planned: "Upcoming", on_hold: "On hold", completed: "Completed" };

const TAG_ICON = { drainage: Droplets, earthworks: Mountain, concrete: Box, asphalt: Route, paving: Route, lifting: Construction, landscaping: Sprout };
export const tagIcon = (tag) => TAG_ICON[tag] || Layers;

export const initials = (name) => (name || "?").split(/\s+/).filter(Boolean).map((p) => p[0]).join("").slice(0, 2).toUpperCase();

export const money = (n) => `$${Math.round(n || 0).toLocaleString("en-NZ")}`;

// Budget used = cost so far ÷ quoted value (real data only).
export function budgetUse(spend) {
  if (!spend?.quoted_value) return null;
  const pct = Math.round(((spend.total || 0) / spend.quoted_value) * 100);
  return { pct, tone: pct > 100 ? "over" : pct >= 80 ? "warn" : "" };
}
